import React from 'react';
import { useReveal } from '../lib/useReveal';
const CHECKOUT = 'https://megapack-maestria-reiki.impultienda.ar/checkout';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  return <section className="relative bg-[#3d2a5f] text-white py-12 md:py-16 px-4 sm:px-6 overflow-hidden border-t border-[#4d3a6f]" data-id="element-111">
      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-112">
        <p className="text-white font-serif italic text-xl sm:text-2xl md:text-3xl font-bold mb-8 md:mb-10" data-id="element-113">
          El próximo paso en tu camino puede empezar hoy.
          <br data-id="element-114" />
          <span className="text-[#c9a14d]" data-id="element-115">
            "El momento que siempre esperaste ya llegó." 🪷
          </span>
        </p>

        <div className="max-w-md mx-auto mb-8 md:mb-10" data-id="element-116">
          {/* Single Product CTA */}
          <div className="bg-[#4d3a6f] rounded-2xl p-6 sm:p-8 border-2 border-[#c9a14d]/50 flex flex-col justify-between relative shadow-[0_20px_50px_rgba(0,0,0,0.3)]" data-id="element-117">
            <div className="mb-6" data-id="element-118">
              <h3 className="text-2xl font-bold text-white mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-119">
                MEGAPACK MAESTRÍA REIKI
              </h3>
              <p className="text-[#c9a14d] font-bold text-sm mb-4" data-id="element-120">
                6 Tomos + 5 Bonos · Niveles I, II y Maestría
              </p>
              <p className="text-white/50 text-sm line-through" data-id="element-121">$69.000</p>
              <p className="text-5xl sm:text-6xl font-extrabold text-white" style={{
              textShadow: '0 0 30px rgba(255,255,255,0.1)'
            }} data-id="element-122">
                $19.990{' '}
                <span className="text-xl font-bold text-white/70" data-id="element-123">ARS</span>
              </p>
            </div>
            <a href={CHECKOUT} target="_blank" rel="noopener noreferrer" className="w-full block px-4 py-4 rounded-xl text-white font-bold text-sm sm:text-base tracking-widest uppercase transition-all shadow-[0_10px_30px_rgba(201,161,77,0.4)] hover:shadow-[0_15px_40px_rgba(201,161,77,0.5)] hover:-translate-y-1 bg-gradient-to-r from-[#c9a14d] to-[#b8945a] border border-[#c9a14d] text-center" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-124">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-white/60 text-[10px] sm:text-xs md:text-sm font-medium" data-id="element-125">
          <span className="flex items-center gap-1.5" data-id="element-126">🔒 Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-127">⚡ Acceso en 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-128">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-129">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}